import { motion } from 'framer-motion'
import { getOptimizedImageUrl } from '../lib/utils'

export default function About({ content }) {
  const mayaImage = getOptimizedImageUrl(content.about_maya_image, 400, 80)
  const hilaImage = getOptimizedImageUrl(content.about_hila_image, 400, 80)

  return (
    <section id="about" className="py-24 px-6 bg-white w-full flex flex-col items-center overflow-hidden font-rubik">
      <div className="w-full max-w-6xl">
        {/* Company About Section */}
        {content.about_company_title && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mb-20 text-center max-w-4xl mx-auto"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
              {content.about_company_title}
            </h2>
            <div className="text-text-light text-lg leading-relaxed whitespace-pre-wrap px-4">
              {content.about_company_text}
            </div>
            <div className="w-24 h-1 bg-primary/20 mx-auto mt-10 rounded-full" />
          </motion.div>
        )}

        {/* Two bios side by side */}
        <div className="grid md:grid-cols-2 gap-12">
          {/* Maya bio */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="bg-warm-light/30 rounded-[3rem] p-10 text-center border border-primary-light/5 hover:shadow-xl transition-all duration-500 group"
          >
            <div className="relative w-40 h-40 mx-auto mb-8">
              <div className="absolute inset-0 bg-primary/10 rounded-full scale-110 group-hover:scale-125 transition-transform duration-700" />
              <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-white shadow-lg">
                {content.about_maya_image ? (
                  <img
                    src={mayaImage}
                    alt={content.about_maya_name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-cream flex items-center justify-center text-4xl text-primary/30">M</div>
                )}
              </div>
            </div>
            <h3 className="text-2xl font-bold text-text mb-4">
              {content.about_maya_name}
            </h3>
            <p className="text-text-light leading-relaxed text-lg">
              {content.about_maya_text}
            </p>
          </motion.div>

          {/* Hila bio */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="bg-warm-light/30 rounded-[3rem] p-10 text-center border border-primary-light/5 hover:shadow-xl transition-all duration-500 group"
          >
            <div className="relative w-40 h-40 mx-auto mb-8">
              <div className="absolute inset-0 bg-secondary/10 rounded-full scale-110 group-hover:scale-125 transition-transform duration-700" />
              <div className="relative w-full h-full rounded-full overflow-hidden border-4 border-white shadow-lg">
                {content.about_hila_image ? (
                  <img
                    src={hilaImage}
                    alt={content.about_hila_name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-cream flex items-center justify-center text-4xl text-primary/30">H</div>
                )}
              </div>
            </div>
            <h3 className="text-2xl font-bold text-text mb-4">
              {content.about_hila_name}
            </h3>
            <p className="text-text-light leading-relaxed text-lg">
              {content.about_hila_text}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
